import React from 'react'
import { useSelector } from 'react-redux'
import { jt, t } from 'ttag'

const MediaKit = () => {
  const mediaKit = useSelector(state => state.mediaKit)
  const values = [
    ...mediaKit.defaultMediaContent,
    ...(mediaKit.tenantMedia[dynamicValues.tenantId] || [])
  ]

  return (
    <div id="educatorportal" className="no-margin">
      <div className="container-fluid">
        <p>{jt`To help promote the ${dynamicValues.systemName}, we offer the following materials which you can print and share to raise awareness of the system and highlight our offerings.`}</p>
        <br />
        <h3 className="section-heading bordered">
          <span>{t`Media Kit`}</span>
        </h3>
        {values.map((m, idx1) => (
          <div className="row holder-row" key={`media-kit-type-${idx1}`}>
            <div
              className="col-xs-12"
              style={{
                padding: '10px',
                backgroundColor: '#fafafa',
                borderTop: '1px dotted #ccc'
              }}>
              <b style={{ color: 'black' }}>{m.displayName}</b>
            </div>
            <div className="col-xs-2 media-type-icon">
              <img
                src={m.imgUrl}
                alt={t`Thumbnail for image to be downloaded`}
                className="img-responsive"
                style={{ marginTop: '25px' }}
              />
            </div>
            <div className="col-xs-10">
              <table className="table tbl media-list-table">
                <thead>
                  <tr>
                    <th className="c1">{t`Title`}</th>
                    <th className="c2">{t`Size`}</th>
                    <th className="c3">{t`Format`}</th>
                    <th className="c4">{t`Actions`}</th>
                  </tr>
                </thead>
                <tbody>
                  {m.items
                    .filter(
                      r =>
                        !r.restrictToSubTenant ||
                        r.restrictToSubTenant === dynamicValues.subTenantId
                    )
                    .map((r, idx) => (
                      <tr
                        className={idx % 2 === 0 ? 'even' : 'odd'}
                        key={`download-link-${idx}`}>
                        <td>{r.title}</td>
                        <td>{r.size}</td>
                        <td>{r.format}</td>
                        <td>
                          <a href={r.url} style={{ whiteSpace: 'nowrap' }}>
                            <i className="fal fa-download"></i> {t`Download`}
                          </a>
                        </td>
                      </tr>
                    ))}
                </tbody>
              </table>
            </div>
          </div>
        ))}

        <br />
      </div>
      <div className="legalbox">
        <div className="container-fluid">
          <h3>{t`Legal`}</h3>
          <p>{t`Please do not:`}</p>
          <div className="col-xs-1">
            <img
              src="/images/headed2/new/media/DoNot.svg"
              alt={t`Do Not`}
              aria-hidden={true}
              className="img-responsive"
            />
          </div>
          <div className="col-xs-3">{t`Display these graphics in a way that implies a relationship, affiliation, or endorsement by Headed2 of your product, service, or business.`}</div>
          <div className="col-xs-1">
            <img
              src="/images/headed2/new/media/DoNot.svg"
              alt={t`Do Not`}
              aria-hidden={true}
              className="img-responsive"
            />
          </div>
          <div className="col-xs-3">{t`Use these graphics as part of your own product, business, or service's name.`}</div>
          <div className="col-xs-1">
            <img
              src="/images/headed2/new/media/DoNot.svg"
              alt={t`Do Not`}
              aria-hidden={true}
              className="img-responsive"
            />
          </div>
          <div className="col-xs-3">{t`Alter these graphics in any way, or combine them with any other graphics, without written consent from Headed2.`}</div>
        </div>
      </div>
    </div>
  )
}

export default MediaKit
